// FontAwesome with tree-shake ability - add only the icons we need for the project
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Import icons from pro-regular, pro-light, and pro-solid
import {
  faCalendarDays as faCalendarDaysRegular,
  faAngleDown as faAngleDownRegular,
  faUser as faUserRegular,
  faMapMarkerAlt as faMapMarkerAltRegular,
  faCheck as faCheckRegular,
  faTimes as faTimesRegular,
  faSearch as faSearchRegular,
  faHeart as faHeartRegular,
  faCheckCircle as faCheckCircleRegular,
  faPhone as faPhoneRegular,
  faEnvelope as faEnvelopeRegular,
  faClock as faClockRegular,
  faTicket as faTicketRegular,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareRegular,
  faArrowRight as faArrowRightRegular,
  faCalendar as faCalendarRegular,
  faArrowLeft as faArrowLeftRegular,
  faXmark as faXmarkRegular,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faUser as faUserLight,
  faCheck as faCheckLight,
  faTimes as faTimesLight,
  faSearch as faSearchLight,
  faHeart as faHeartLight,
  faCheckCircle as faCheckCircleLight,
  faPhone as faPhoneLight,
  faEnvelope as faEnvelopeLight,
  faClock as faClockLight,
  faTicket as faTicketLight,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareLight,
  faArrowRight as faArrowRightLight,
  faArrowLeft as faArrowLeftLight,
  faCalendar as faCalendarLight,
  faUsers as faUsersLight,
  faBus as faBusLight,
  faViolin as faViolinLight,
} from '@fortawesome/pro-light-svg-icons'

import {
  faBookOpen as faBookOpenSolid,
  faUser as faUserSolid,
  faCheck as faCheckSolid,
  faTimes as faTimesSolid,
  faSearch as faSearchSolid,
  faHeart as faHeartSolid,
  faCheckCircle as faCheckCircleSolid,
  faPhone as faPhoneSolid,
  faEnvelope as faEnvelopeSolid,
  faClock as faClockSolid,
  faTicket as faTicketSolid,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareSolid,
  faArrowRight as faArrowRightSolid,
  faArrowLeft as faArrowLeftSolid,
  faArrowUp as faArrowUpSolid,
  faCircleXmark as faCircleXmarkSolid,
  faChevronUp as faChevronUpSolid,
} from '@fortawesome/pro-solid-svg-icons'

import {
    faArrowRight as faArrowRightRegularSharp,
    faArrowLeft as faArrowLeftRegularSharp
 } from '@fortawesome/sharp-regular-svg-icons'


// Add all variants to the library
library.add(
  // Regular
  faCalendarDaysRegular, faAngleDownRegular, faMapMarkerAltRegular, faUserRegular, faCheckRegular, faTimesRegular, faSearchRegular,
  faHeartRegular, faCheckCircleRegular, faPhoneRegular, faEnvelopeRegular,
  faClockRegular, faTicketRegular, faArrowUpRightFromSquareRegular,
  faArrowRightRegular, faArrowLeftRegular, faCalendarRegular, faXmarkRegular,

  // Light
  faUserLight, faCheckLight, faTimesLight, faSearchLight,
  faHeartLight, faCheckCircleLight, faPhoneLight, faEnvelopeLight,
  faClockLight, faTicketLight, faArrowUpRightFromSquareLight,
  faArrowRightLight, faArrowLeftLight, faCalendarLight, faUsersLight, faBusLight, faViolinLight, faTicketLight,

  // Solid
  faBookOpenSolid, faUserSolid, faCheckSolid, faTimesSolid, faSearchSolid,
  faHeartSolid, faCheckCircleSolid, faPhoneSolid, faEnvelopeSolid,
  faClockSolid, faTicketSolid, faArrowUpRightFromSquareSolid,
  faArrowRightSolid, faArrowLeftSolid, faArrowUpSolid, faCircleXmarkSolid,
  faChevronUpSolid,

  //Reg Sharp
  faArrowRightRegularSharp, faArrowLeftRegularSharp,

)

dom.watch() // Replace <i> tags with <svg>
